import { useState, useEffect } from 'react';
import { User, LeaderboardType } from '../types';
import { getLeaderboard, getMemoryLeaderboard, getMemoryRankingBoard, getNewsRankingBoard } from '../services/leaderboardService';

export const useLeaderboard = (type: LeaderboardType) => {
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    // Subscribe to the leaderboard data
    const unsubscribe = getLeaderboard(
      type,
      (fetchedUsers) => {
        setUsers(fetchedUsers);
        setLoading(false);
      },
      10
    );

    // Cleanup subscription on unmount
    return () => {
      unsubscribe();
    };
  }, [type]);

  return { users, loading, error };
};

// Memory game only leaderboard
export const useMemoryLeaderboard = (type: LeaderboardType) => {
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    const unsubscribe = getMemoryLeaderboard(
      type,
      (fetchedUsers) => {
        setUsers(fetchedUsers);
        setLoading(false);
      },
      10
    );

    return () => {
      unsubscribe();
    };
  }, [type]);

  return { users, loading, error };
};

// Memory game RankingBoard hook
export const useMemoryRankingBoard = (type: LeaderboardType) => {
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    const unsubscribe = getMemoryRankingBoard(
      type,
      (fetchedUsers) => {
        setUsers(fetchedUsers);
        setLoading(false);
      },
      10
    );

    return () => {
      unsubscribe();
    };
  }, [type]);

  return { users, loading, error };
};

// News RankingBoard hook
export const useNewsRankingBoard = (type: LeaderboardType) => {
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    const unsubscribe = getNewsRankingBoard(
      type,
      (fetchedUsers) => {
        setUsers(fetchedUsers);
        setLoading(false);
      },
      10
    );

    return () => {
      unsubscribe();
    };
  }, [type]);

  return { users, loading, error };
};